<template>
  <crud-template
      @deleteItem="deleteItem"
      @dialogClosed="clearForm"
      ref="formTemplate" :editedItem.sync="formData">
    <template #default="{editItemHandler}">
      <div class="text-right mb-3">
        <btn-with-tooltip @click="editItemHandler('create')" class-name="action-btn" color="primary">
          <v-icon small>fas fa-plus</v-icon>
          <template #tooltip>Создать</template>
        </btn-with-tooltip>
      </div>
      <v-data-table
          disable-pagination
          :headers="headers"
          hide-default-footer
          :items="items">
        <template #item.status="{item}">
          <v-switch @change="changeStatus(item)" class="ma-0" :loading="item.loading" :label="item.status ? 'Активный' : 'Не активный'" v-model="item.status"></v-switch>
        </template>
        <template #item.action="{item}">
          <div class="action-btn-wrap">
            <v-btn @click="editItemHandler('edit', item)" class="action-btn" color="warning">
              <v-icon x-small>fas fa-pencil-alt</v-icon>
            </v-btn>
            <v-btn @click="editItemHandler('delete', item)" class="action-btn" color="error">
              <v-icon x-small>fas fa-trash</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </template>

    <template #form-content="{isUpdate, loading}">
      <validation-observer ref="formObs" v-slot="{handleSubmit}">
        <form @submit.prevent="handleSubmit(() => save(isUpdate))">
          <v-row class="form-dialog-modal">
            <v-col sm="6" cols="12">
              <custom-input-text
                  label="Имя"
                  vid="name"
                  v-model="formData.name"
                  rules="required"
              ></custom-input-text>
            </v-col>
            <v-col sm="6" cols="12">
              <custom-input-text
                  label="Фамилия"
                  vid="sourname"
                  v-model="formData.sourname"
                  rules="required"
              ></custom-input-text>
            </v-col>
            <v-col sm="6" cols="12">
              <custom-input-text
                  label="Должность"
                  vid="position"
                  v-model="formData.position"
                  rules="required"
              ></custom-input-text>
            </v-col>
            <v-col sm="6" cols="12">
              <custom-input-text
                  prefix="+998"
                  pattern="##-###-##-##"
                  label="Номер телефона"
                  rules="required|phone"
                  vid="phone"
                  v-model="formData.phone"
              ></custom-input-text>
            </v-col>
            <v-col cols="12">
              <v-btn width="100%" color="primary" type="submit" :loading="loading">Сохранить</v-btn>
            </v-col>
          </v-row>

        </form>
      </validation-observer>
    </template>
  </crud-template>
</template>

<script>
import crudTemplate from "@/components/ui/crud/template";
import {messages} from '@/utils/constants'
import {refactorNumber} from "@/utils/pureFunctions";

const WORKER_DEFAULT_FORM_DATA = {
  name: null,
  sourname: null,
  phone: null,
  position: null
}

export default {
  data() {
    return {
      formData: {
        ...WORKER_DEFAULT_FORM_DATA
      },
      headers: [
        {
          text: 'Название',
          value: 'name'
        },
        {
          text: 'Фамилия',
          value: 'sourname'
        },
        {
          text: 'Должность',
          value: 'position'
        },
        {
          text: 'Телефон',
          value: 'phone'
        },
        {
          text: 'Стастус',
          value: 'status'
        },
        {
          text: 'Действие',
          value: 'action'
        }
      ],
      items: [],
    }
  },
  methods: {
    async deleteItem(item) {
      this.$showLoading()
      try {
        await this.$http.delete(`admin/workers/${item.id}`)
        this.items = this.items.filter(worker => {
          return worker.id !== item.id
        })
        this.$setSuccess({text: messages.onDelete})
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.$clearLoading()
      }
    },
    async clearForm() {
      const {formObs} = this.$refs
      if (formObs) formObs.reset()
    },
    async getItems() {
      try {
        const {data: {data}} = await this.$http.get('admin/workers')
        this.items = data.map(item => {
          item.loading = false
          return item
        })
      } catch (e) {
        this.$setResponseError({error: e})
      }

    },
    async save(isUpdate) {
      const {formTemplate} = this.$refs
      const formData = {...this.formData}
      formData.mko_id = this.$store.getters.mko ? this.$store.getters.mko.id : null
      formData.phone = refactorNumber({prefix: '998', number: formData.phone, removeSymbol: '-'})
      if (formTemplate) formTemplate.$showFormLoading()
      try {
        if (isUpdate) {
          await this.update(formData)
        } else {
          await this.create(formData)
        }
        formTemplate.$clearFormLoading()
        if (formTemplate) {
          formTemplate.closeFormDialog()
        }
        this.$setSuccess({text: messages.onSave})

      } catch (e) {
        this.$setResponseError({error: e})
        this.$setFormError({error: e, obs: this.$refs.formObs})
        formTemplate.$clearFormLoading()

      }
    },
    async create(formData) {
      try {
        const {data: {data}} = await this.$http.post("admin/workers", formData)
        data.loading = false
        this.items.push(data)
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async update(formData) {
      const {id} = this.formData
      try {
        await this.$http.put(`admin/workers/${id}`, formData)
        await this.getItems()
      } catch (e) {
        return Promise.reject(e)
      }

    },
    async changeStatus(item) {
      item.loading = true
      try {
         await this.$http.post(`admin/workers/change-status/${item.id}`)
        this.$setSuccess({text: messages.onSave})
      } catch (e) {
        this.$setResponseError({error: e})
        item.status = !item.status
      } finally {
        item.loading = false
      }

    },

  },
  components: {crudTemplate},
  async created() {
    this.$showLoading()
    await this.getItems()
    this.$clearLoading()
  }
}
</script>
